import { render, staticRenderFns } from "./HorizontalBarChart.vue?vue&type=template&id=bc11de3c&scoped=true"
import script from "./HorizontalBarChart.vue?vue&type=script&lang=js"
export * from "./HorizontalBarChart.vue?vue&type=script&lang=js"
import style0 from "./HorizontalBarChart.vue?vue&type=style&index=0&id=bc11de3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc11de3c",
  null
  
)

export default component.exports